import { useState } from 'react';


export function useInput(initialValue, initialName) {
  const [error, setError] = useState([`This field is required`]);
  const [value, setValue] = useState(initialValue);
  const validate = (name, value) => {
    let err = [];
    if (!value) {
      err.push(`This field is required`);
    }
    setError(err);
  };
  //Value in return statement must remain in order to have the value hook in the form
  return {
    value,
    errorDisp: error,
    bind: {
      value,
      onChange: e => {
        setValue(e.target.value);
        validate(initialName, e.target.value);
      }
    },

  };
}

export function useCheckBoxInput(initialValue) {
  const [errorDisp, setError] = useState([`This must be checked`]);
  const [value, setValue] = useState(initialValue);

  const validate = (checked) => {
    let err = [];
    if (!checked) {
      err.push(`This must be checked`);
    }
    setError(err);
  };

  const bind = {
    checked: value,
    onChange: (e) => {
      setValue(e.target.checked);
      validate(e.target.checked);
    }
  };

  return {
    value, bind, errorDisp
  };
}

export function useInputNumeric(initialValue) {
  const [value, setValue] = useState(initialValue);
  const increment = (value) => {
    const newValue = Math.ceil(value / 5) * 5;
    setValue(newValue);
  };
  //Value in return statement must remain in order to have the value hook in the form
  return {
    value,
    bind: {
      value,
      onChange: e => {
        increment(e.target.value);
      }
    },

  };
}

export function useInputPhone(initialValue, initialName) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState([`This field is required`]);
  const validate = (name, value) => {
    let err = [];
    if (!value) {
      err.push(`This field is required`);
    }
    setError(err);
  };
  //Value in return statement must remain in order to have the value hook in the form
  return {
    value,
    errorDisp: error,
    bind: {
      value,
      onChange: e => {
        let formattedNum = formatPhoneNumber(e.target.value)
        setValue(formattedNum);
        validate(initialName, e.target.value);
      }
    }
  };
};

export function useInputPostalCode(initialValue, initialName) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState([`This field is required`]);
  const validate = (name, value) => {
    let err = [];
    if (!value) {
      err.push(`This field is required`);
    }
    setError(err);
  };
  //Value in return statement must remain in order to have the value hook in the form
  return {
    value,
    errorDisp: error,
    bind: {
      value,
      onChange: e => {
        let formattedCode = formatPostalCode(e.target.value)
        setValue(formattedCode);
        validate(initialName, e.target.value);
      }
    }
  };
};

export function useInputEmail(initialValue, initialName) {
  const [value, setValue] = useState(initialValue);
  const [errors, setErrors] = useState([`This field is required`, `Invalid email address`]);
  const validate = (name, value) => {
    let err = [];
    if (!value) {
      err.push(`This field is required`);
    }
    if (!/\S+@\S+\.\S+/.test(value)) {
      err.push(`Invalid email address`);
    }
    setErrors(err);
  };
  //Value in return statement must remain in order to have the value hook in the form
  return {
    value,
    errorDisp: errors,
    bind: {
      value,
      onChange: e => {
        setValue(e.target.value);
        validate(initialName, e.target.value);
      },

    }
  };
}

const formatPostalCode = (value) => {
  if (!value) return value;
  const postalCode = value.replace(/[^\d]/g, "");
  const postalCodeLength = postalCode.length;
  if (postalCodeLength < 6) return postalCode;
  if (postalCodeLength < 8) {
    return `${postalCode.slice(0, 5)}-${postalCode.slice(5, 8)}`;
  }

  return `${postalCode.slice(0, 5)}-${postalCode.slice(5, 9)}`;
}



const formatPhoneNumber = (value) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

export function FormFieldHelper() {
  return (<div>
  </div>)
}